export default __webpack_public_path__ + "static/media/refresh.16e935dd.svg";